import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { DettaglioLineePRModalComponent } from './dettaglio-linee-pr-modal';

export const DettaglioLineePRModalModule: string = ng
    .module('dettaglio-linee-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('dettaglioLineePRModalComponent', DettaglioLineePRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/dettaglio-linee-pr-modal/dettaglio-linee-pr-modal.module.ts